<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 25 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_530_20054)">
      <path
        d="M0.000123873 18.7399L0.000123873 10.2235C0.000123873 9.09471 0.448544 8.01214 1.24674 7.21394C2.04493 6.41575 3.12752 5.96731 4.25634 5.96731H12.7844C13.9136 5.96731 14.9966 6.41562 15.7954 7.2137C16.5942 8.01178 17.0435 9.09435 17.0446 10.2235V18.7399C17.0446 19.8697 16.5957 20.9533 15.7968 21.7522C14.9979 22.5512 13.9143 23 12.7844 23H4.26025C3.70066 23.0005 3.14646 22.8907 2.62936 22.6768C2.11227 22.4629 1.64243 22.1491 1.24674 21.7534C0.851047 21.3577 0.537263 20.8879 0.323354 20.3708C0.109444 19.8537 -0.000391169 19.2995 0.000123873 18.7399Z"
        fill="url(#paint0_linear_530_20054)"
      />
      <path
        d="M7.04822 12.7726L7.04822 4.25625C7.04822 3.69699 7.15844 3.14322 7.37258 2.62658C7.58672 2.10993 7.90058 1.64056 8.29622 1.24528C8.69186 0.850002 9.16152 0.536575 9.67836 0.32291C10.1952 0.109245 10.7491 -0.00047493 11.3083 4.00543e-05H19.8247C20.9539 3.8147e-05 22.0369 0.448345 22.8357 1.24643C23.6345 2.04451 24.0838 3.12707 24.0848 4.25625V12.7726C24.0838 13.9011 23.635 14.9831 22.8371 15.7811C22.0391 16.579 20.9571 17.0278 19.8286 17.0288H11.3083C10.7491 17.0293 10.1952 16.9196 9.67836 16.706C9.16152 16.4923 8.69186 16.1789 8.29622 15.7836C7.90058 15.3883 7.58672 14.9189 7.37258 14.4023C7.15844 13.8857 7.04822 13.3319 7.04822 12.7726Z"
        fill="url(#paint1_linear_530_20054)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_530_20054"
        x1="-3.63352"
        y1="6.24923"
        x2="16.8723"
        y2="20.1416"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#00A7FF" stop-opacity="0.2" />
        <stop offset="1" stop-color="#00A7FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_530_20054"
        x1="19.7033"
        y1="13.8376"
        x2="10.443"
        y2="1.93041"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#177AF0" />
        <stop offset="0.99" stop-color="#177AF0" stop-opacity="0.2" />
      </linearGradient>
      <clipPath id="clip0_530_20054">
        <rect width="24.0807" height="23" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'ELTCDCIcon',
  props: {
    height: VueTypes.string.def('16'),
    width: VueTypes.string.def('16'),
  },
};
</script>

<style lang="scss"></style>
